module.exports = __webpack_public_path__ + "img/qrcode_for.dc594565.jpg";